import {
    FormCheckbox, FormInput, FormRadio, FormSelect, InfluencersModal, MediaModal, PeoplePicker, Modal
} from "@/components/index";
import { ActivationStatus, UploadFileStatus, AssociatedEnum } from "@/enums";
import {
    IActivation, IActivationCase, IActivationCreate, IActivationType, IBrandQualityWithChildren, IBrandWithChildren, IHashtag,
    IKeyword, IMarketWithChildren, IUploadFile, IUser, IUserGraph, ILinkFile, IMarket, IBrand,
} from "@/models/index";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
    name: "ActivationForm",
    components: {
        ValidationProvider,
        ValidationObserver,
        PeoplePicker,
        FormSelect,
        FormCheckbox,
        FormRadio,
        FormInput,
        MediaModal,
        InfluencersModal,
        Modal,
    },
})
export default class ActivationForm extends Vue {

    public activationId = 0;

    public UploadFiles: IUploadFile = {
        activationId: 0,
        files: null,
        fileName: "",
        blobName: "",
        importFileId: 0,
    };

    public isMediaModalAvailable: boolean = false;

    public isInfluencerModalAvailable: boolean = false;

    public filesToRemove: IUploadFile[] = [];

    public loading: boolean = false;

    public crossMarketName = "cross-market";

    public crossBrandName = "cross-brand";

    public crossMarket: IMarket = null;

    public crossBrand: IBrand = null;

    public selectedInfluencers = [];

    public selected = "";

    public mediaModal = false;

    public influencersModal = false;

    public currentUser: IUser[] = [];

    public userGraphs: IUserGraph[] = [];

    public modalclose = null;

    datestart = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);

    dateend = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);

    public menu = false;

    public menu2 = false;

    public addenddate = false;

    public menu1 = false;

    public alertdate = false;

    public links: ILinkFile[] = [];

    public files: File[] = [];

    public influencerFile: File = null;

    public influencerFileStatus = UploadFileStatus.None;

    public associatedQueries = AssociatedEnum.Queries;

    public associatedInsight = AssociatedEnum.Insight;

    public showModal: boolean = false;

    public mediaEdited: boolean = false;

    public ActivationTypes: IActivationType = {
        activationTypeId: 0,
        code: "",
        labelActivationType: "",
    };

    public ActivationCases: IActivationCase = {
        activationCaseId: 0,
        code: "",
        labelActivationCase: "",
    };

    public user: IUser = {
        userId: 0,
        email: "",
        name: "",
        roleId: 0,
        role: "",
        userUniqueId: "",
        isActive: false,
        prAffiliatePermissions: [],
    };

    public Activation: IActivationCreate = {
        activationId: 0,
        activationTypeId: 0,
        activationCaseId: 0,
        activationName: "",
        activationTitle: "",
        description: "",
        location: "",
        insightPage: "",
        comment: "",
        startDate: null,
        endDate: null,
        campaignExist: 0,
        userUniqueId: this.userId,
        markets: [],
        brands: [],
        brandsQuality: [],
        keywords: [],
        hashtags: [],
        parentActivationId: 0,
        status: 1,
        tags: [],
        influencerBlobName: "",
        influencersFilename: "",
        influencerCreatedDate: null,
        insightPages: [""],
        queriesAssociated: [""],
    };

    public currentActivation: IActivation = null;

    public influencersFileIsValid = true;

    get concatMediaFilesName(): string {
        const result = this.currentMediaFiles.map(a => a.name);
        return result.join(", ");
    }


    get concatLinkFilesName(): string {
        const result = this.links.map(a => a.link);
        return result.join(", ");
    }

    get influencerFileName(): string {
        return this.influencerFile.name;
    }

    get isEditing(): boolean {
        return this.activationId !== 0;
    }

    get getLinks(): ILinkFile[] {
        return this.links;
    }

    get hideOrShowMediaModal(): boolean {
        return this.isMediaModalAvailable;
    }

    get hideOrShowInfluencerModal(): boolean {
        return this.isInfluencerModalAvailable;
    }

    get showMediaModel(): boolean {
        if (!this.isEditing) {
            return true;
        }
        return !this.isLoadingActivation && this.currentActivation !== null;
    }

    get initialFiles(): IUploadFile[] {
        return this.currentActivation?.files ?? [];
    }

    get currentMediaFiles(): File[] {
        return this.files ?? [];
    }

    get currentInfluencerFile(): File {
        return this.influencerFile ?? null;
    }

    get filesLength(): number {
        return this.files.length + this.initialFiles.length - this.filesToRemove.length;
    }

    get isLoadingActivation(): boolean {
        return this.isEditing && this.currentActivation === null;
    }

    get showSaveAsDraftButton(): boolean {
        return this.Activation.status === ActivationStatus.Draft;
    }

    get initialInfluencerFilename(): string {
        return this.Activation?.influencersFilename ?? "";
    }

    get influencersFilename(): string {
        return this.Activation?.influencersFilename;
    }

    addFieldAssociated(index: number, type: number): void {
        if(type === AssociatedEnum.Queries) {
            this.Activation.queriesAssociated.push(this.Activation.queriesAssociated[index+1]);
        }
        else if(type === AssociatedEnum.Insight) {
            this.Activation.insightPages.push(this.Activation.insightPages[index+1]);
        }
    }

    removeFieldAssociated(index: number, type: number): void {
        if(type === AssociatedEnum.Queries) {
            this.Activation.queriesAssociated.splice(index, 1);
        }
        else if(type === AssociatedEnum.Insight) {
            this.Activation.insightPages.splice(index, 1);
        }
    }

    async saveActivation(saveAsDraft: boolean): Promise<void> {
        const action = this.isEditing ? "editActivation" : "addActivation";
        const message = this.isEditing ? "updated" : "created";
        try {

            this.setActivationStatus(saveAsDraft);

            // TODO find a better way
            // This flags the file for deletion by the back end
            if (this.influencerFileStatus === UploadFileStatus.Deleted) {
                this.Activation.influencersFilename = "";
            }

            this.activationTitle();

            const activationFormData = this.getActivationFormData();
            const res = await this.$store.dispatch(`app/${action}`, activationFormData);
            const formData = new FormData();
            if (this.mediaEdited) {
                const currentId = this.$store.getters["app/activationCreate"];
                formData.append("activationId", currentId);

                if (this.links.length === 0) {
                    formData.append("filesLink", JSON.stringify(null) )
                } else {
                    this.links.forEach(link => {
                        formData.append("filesLink", JSON.stringify(link));
                    });
                }

                this.filesToRemove.forEach(file => {
                    formData.append("fileIdsToRemove", `${file.importFileId}`);
                });

                this.files.forEach(file => {
                    formData.append("files", file);
                });

                await this.$store.dispatch("app/uploadFiles", formData);
            }

            if (res !== null) {
                this.$emit("success", `The Activation has been successfully ${message}.`);
            } else {
                this.$emit("error", `An error has occurred.`);
            }

            if (!this.isEditing) {
                setTimeout(() => {
                    this.$router.replace({ name: "home" });
                }, 1500);
            }
            else {
                this.$router.replace({ name: "showActivation" });
            }
        }
        catch (error) {
            this.$emit("error", error);
        }
    }

    activationTitle(): string {
        if (this.Activation.brands.length > 1) {
            this.Activation.activationTitle = "cross-brand_";
        }
        else {
            const brandName = this.Activation.brands.length === 0 ? "x" :
                (this.brands.find(brand => brand.brandId === this.Activation.brands[0])?.name ?? "x");
            this.Activation.activationTitle = brandName + "_";
        }
        if (this.Activation.brandsQuality.length > 1) {
            this.Activation.activationTitle += "cross-product_";
        }
        else {
            const brandQualityName = this.Activation.brandsQuality.length === 0 ? "x" :
                (this.brandsQuality.find(brandQuality => brandQuality.brandQualityId === this.Activation.brandsQuality[0])?.name ?? "x");
            this.Activation.activationTitle += brandQualityName + "_";
        }
        if (this.Activation.markets.length > 1) {
            this.Activation.activationTitle += "cross-market_";
        }
        else {
            const marketName = this.Activation.markets.length === 0 ? "x" :
                (this.markets.find(market => market.marketId === this.Activation.markets[0])?.name ?? "x");
            this.Activation.activationTitle += marketName + "_";
        }

        this.Activation.activationTitle += this.Activation.activationName.toString() + "_";
        this.Activation.activationTitle += moment(this.Activation.startDate).format("MM-YY");
        return this.Activation.activationTitle;
    }

    submit(): void {
        const observer = this.$refs.observer as InstanceType<typeof ValidationObserver>;
        observer.validate();
        this.activationTitle();
        this.showModal = true;
    }

    async confirm(): Promise<void> {
        this.closeModal();
        await this.saveActivation(false);
    }

    closeModal(): void {
        this.showModal = false;
    }

    verifdate(): void {
        if (this.Activation.endDate !== null) {
            if (moment(this.Activation.startDate) > moment(this.Activation.endDate)) {
                this.alertdate = true;
            }
            else {
                this.alertdate = false;
            }
        }
    }

    openInfluencersModal(): void {
        this.isInfluencerModalAvailable = true;
        this.$nextTick(() => {
            this.influencersModal = true;
        });
    }

    openMediaModal(): void {
        this.isMediaModalAvailable = true;
        this.$nextTick(() => {
            this.mediaModal = true;
        });
    }

    closeInfluencersModal(): void {
        this.influencersModal = false;
        this.isInfluencerModalAvailable = false;
    }

    closeMediaModal(): void {
        this.mediaModal = false;
        this.isMediaModalAvailable = false;
    }

    onMarketChange(newValue: any): void {
        if (this.crossMarket) {
            if (newValue.includes(this.crossMarket.marketId)) {
                this.Activation.markets = [this.crossMarket.marketId];
                return;
            }
        }

        this.Activation.markets = newValue;
    }

    onBrandChange(newValue: any): void {
        if (this.crossBrand) {
            if (newValue.includes(this.crossBrand.brandId)) {
                this.Activation.brands = [this.crossBrand.brandId];
                return;
            }
        }

        this.Activation.brands = newValue;
    }

    get influencersLink(): string {
        const url = window.URL || window.webkitURL;
        const data = this.$store.getters["app/influencers"];
        return data ? url.createObjectURL(data) : "";
    }

    get activationTypes(): IActivationType[] {
        return this.$store.getters["app/activationtype"];
    }

    get activationCases(): IActivationCase[] {
        const activationcase: IActivationCase[] = this.$store.getters["app/activationcase"];
        return activationcase;
    }

    get activations(): IActivation[] {
        const activations: IActivation[] = this.$store.getters["app/activations"];
        return activations;
    }

    get keywords(): IKeyword[] {
        const keywords: IKeyword[] = this.$store.getters["app/keywords"];
        return keywords;
    }

    get hashtags(): IHashtag[] {
        const hashtags: IHashtag[] = this.$store.getters["app/hashtags"];
        return hashtags;
    }

    get brands(): IBrand[] {
        let brands: IBrandWithChildren[] = this.$store.getters["app/brands"];
        this.crossBrand = brands.filter(m => m.code === this.crossBrandName)[0];

        let allbrands: IBrand[] = [];
        brands.forEach((brand: IBrandWithChildren) => {
            allbrands.push(brand);
            brand.children.forEach((child: IBrand) => {
                allbrands.push(child);
            });
        });


        this.crossBrand = allbrands.filter(m => m.code === this.crossBrandName)[0];

        if (this.crossBrand == null) {
            return brands;
        }

        //alphabetic sort
        allbrands = allbrands.sort( (a, b) => (
            a.name.localeCompare(b.name)
        ));

        allbrands = allbrands.filter(m => m.code !== this.crossBrandName);
        allbrands = [this.crossBrand, ...allbrands];

        return allbrands;
    }

    get brandsQuality(): IBrandQualityWithChildren[] {
        const brandsQuality: IBrandQualityWithChildren[] = this.$store.getters["app/brandsQuality"];
        return brandsQuality;
    }

    get markets(): IMarket[] {
        let markets: IMarketWithChildren[] = this.$store.getters["app/markets"];

        let allMarkets: IMarket[] = [];
        markets.forEach((market: IMarketWithChildren) => {
            allMarkets.push(market);
            market.children.forEach((child: IMarket) => {
                allMarkets.push(child);
            });
        });

        this.crossMarket = allMarkets.filter(m => m.code === this.crossMarketName)[0];

        if (this.crossMarket == null) {
            return markets;
        }

        //alphabetic sort
        allMarkets = allMarkets.sort( (a, b) => (
            a.name.localeCompare(b.name)
        ));

        allMarkets = allMarkets.filter(m => m.code !== this.crossMarketName);
        allMarkets = [this.crossMarket, ...allMarkets];

        return allMarkets;
    }

    get requiredFalse():boolean {
        return false;
    }

    get userId(): string {
        return this.$store.getters["account/userId"];
    }

    get users(): IUser[] {
        const users: IUser[] = this.$store.getters["app/users"];
        return users;
    }

    setActivationStatus(saveAsDraft: boolean): void {

        if (this.Activation.status === ActivationStatus.Live) {
            return;
        }

        this.Activation.status = saveAsDraft ? ActivationStatus.Draft : ActivationStatus.SubmittedNotLiveYet;

    }

    checkInfluencersFileIsValid(): boolean {
        const filename = this.influencerFile?.name;
        if (filename) {
            const authorizedExtensions = process.env.VUE_APP_INFLUENCERS_AUTHORIZED_EXTENSIONS?.split(",") ?? ["xlsx", "xls"];
            const extension = this.getExtension(filename);
            return authorizedExtensions.some(ext => ext.toLowerCase() === extension.toLowerCase());
        }
        else {
            return true;
        }
    }

    handleChangeLinks(links: ILinkFile[]): void {
        this.mediaEdited = true;
        this.links = links;
    }

    handleChangeFiles(files: File[]): void {
        this.files = files;
    }

    handleRemoveFiles(files: IUploadFile[]): void {
        this.filesToRemove = files;
    }

    // TODO test if already a file and no change
    handleChangeInfluencers(files: File[], fileStatus: UploadFileStatus): void {
        this.influencerFile = files.length ? files[0] : null;
        this.influencersFileIsValid = this.checkInfluencersFileIsValid();
        this.influencerFileStatus = fileStatus;
    }

    async mounted(): Promise<void> {
        this.loading = true;
        try {

            this.activationId = this.$route.params.id ? Number(this.$route.params.id) : 0;
            this.$store.dispatch("app/resetInfluencers");

            await Promise.all([
                this.$store.dispatch("app/loadAllActivationType", true),
                this.$store.dispatch("app/loadAllActivationCase", true),
                this.$store.dispatch("app/loadAllKeywords", true),
                this.$store.dispatch("app/loadAllHashtags", true),
                this.$store.dispatch("app/loadUsers", true),
                this.$store.dispatch("app/loadAllBrand", true),
                this.$store.dispatch("app/loadAllBrandQuality", true),
                this.$store.dispatch("app/loadAllMarket", true),
                this.$store.dispatch("app/loadActivationUsers", this.activationId),
            ]);

            if (this.isEditing) {
                await this.$store.dispatch("app/loadActivationById", this.activationId);
                this.currentActivation = this.$store.getters["app/currentActivation"];
                this.Activation = {
                    activationId: this.currentActivation.activationId,
                    activationTypeId: this.currentActivation.activationTypeId,
                    activationCaseId: this.currentActivation.activationCaseId,
                    activationName: this.currentActivation.activationName,
                    activationTitle: this.currentActivation.activationTitle,
                    description: this.currentActivation.description,
                    location: this.currentActivation.location,
                    insightPage: this.currentActivation.insightPage,
                    comment: this.currentActivation.comment,
                    startDate: (this.currentActivation.startDate != null) ? moment(this.currentActivation.startDate).format("YYYY-MM-DD") : null,
                    endDate: (this.currentActivation.endDate != null) ? moment(this.currentActivation.endDate).format("YYYY-MM-DD") : null,
                    campaignExist: this.currentActivation.campaignExist,
                    userUniqueId: this.currentActivation.userUniqueId,
                    markets: this.currentActivation.markets.map(m => m.marketId),
                    brands: this.currentActivation.brands.map(n => n.brandId),
                    brandsQuality: this.currentActivation.brandsQuality.map(n => n.brandQualityId),
                    keywords: this.keywords.filter(keyword => this.currentActivation.keywords.some(campaignKeyword => campaignKeyword.keywordId === keyword.keywordId)),
                    hashtags: this.hashtags.filter(hashtag => this.currentActivation.hashtags.some(campaignHashtag => campaignHashtag.hashtagId === hashtag.hashtagId)),
                    parentActivationId: this.currentActivation.parentActivationId,
                    tags: this.currentActivation.tags.map(t => t.tagId),
                    status: this.currentActivation.statusId,
                    influencerBlobName: this.currentActivation.influencerBlobName,
                    influencersFilename: this.currentActivation.influencersFilename,
                    influencerCreatedDate: this.currentActivation.influencerCreatedDate,
                    insightPages: this.currentActivation.insightPages.length > 0? this.currentActivation.insightPages.map(item => item.link) : [""],
                    queriesAssociated: this.currentActivation.queriesAssociated.length > 0? this.currentActivation.queriesAssociated.map(item => item.link) : [""],
                };

                this.links = this.currentActivation.filesLink;

                // TODO delete?
                if (this.Activation.influencerBlobName) {
                    this.loadInfluencerFile();
                }
            }
        }
        catch (error) {
            this.$emit("error", error);
        }

        this.loading = false;
    }

    async loadInfluencerFile(): Promise<void> {
        try {
            await this.$store.dispatch("app/loadInfluencers", this.Activation.influencerBlobName);
        }
        catch {
            this.$notify({ type: "error", duration: 8000, text: "Could not load the influencers file" });
        }
    }

    clear(scroll = true): void {
        const observer = this.$refs.observer as InstanceType<typeof ValidationObserver>;
        observer.reset();

        this.resetFields();

        if (scroll) {
            window.scrollTo(0, 0);
        }
    }

    resetFields(): void {
        this.Activation.activationId= 0;
        this.Activation.activationTypeId= 0;
        this.Activation.activationCaseId= 0;
        this.Activation.activationName= "";
        this.Activation.activationTitle= "";
        this.Activation.description= "";
        this.Activation.location= "";
        this.Activation.insightPage= "";
        this.Activation.comment= "";
        this.Activation.startDate= null;
        this.Activation.endDate= null;
        this.Activation.campaignExist= 0;
        this.Activation.userUniqueId= this.userId;
        this.Activation.markets= [];
        this.Activation.brands= [];
        this.Activation.brandsQuality= [];
        this.Activation.keywords= [];
        this.Activation.hashtags= [];
        this.Activation.parentActivationId= 0;
        this.Activation.status= 1;
        this.Activation.tags= [];
        this.Activation.influencerBlobName= "";
        this.Activation.influencersFilename= "";
        this.Activation.influencerCreatedDate= null;
        this.Activation.insightPages= [""];
        this.Activation.queriesAssociated= [""];
        this.links = [];
        this.influencerFile = null;
        this.influencerFileStatus = 0;
        this.mediaEdited = false;
        this.files = [];
        this.filesToRemove = [];
    }

    onHashtagsChange(hashtags: (IHashtag | string)[]): void {
        if (hashtags.length > 0) {
            const lastItem = hashtags[hashtags.length - 1];
            if (typeof lastItem === "string") {
                hashtags[hashtags.length - 1] = { hashtagId: 0, code: "", labelHashtag: lastItem };
            }
        }
        this.Activation.hashtags = hashtags as IHashtag[];
    }

    onKeywordsChange(keywords: (IKeyword | string)[]): void {
        if (keywords.length > 0) {
            const lastItem = keywords[keywords.length - 1];
            if (typeof lastItem === "string") {
                keywords[keywords.length - 1] = { keywordId: 0, code: "", labelKeyword: lastItem };
            }
        }
        this.Activation.keywords = keywords as IKeyword[];
    }

    private getActivationFormData(): FormData {
        const formData = new FormData();
        const json = { "activationCreate": this.Activation };
        formData.append("json", JSON.stringify(json));

        if (this.influencerFile && this.influencerFileStatus === UploadFileStatus.Updated){
            formData.append("influencersFile", this.influencerFile);
        }

        return formData;
    }

    // TODO refacto pour mettre en commun avec activation show form
    private getExtension(filename: string): string {
        return filename.substring(filename.lastIndexOf(".") + 1, filename.length) || "";
    }

}
